import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr/index'

const tagApi = createAggrApiInstance(aggr.TagsTagApi)

export const queryAllTags = async (reqData: aggr.TagQueryAllRq) => {
  const res = await handleApiStatus(() => tagApi.tagQueryall(reqData))
  return res
}

export const queryTagDetail = async (mainTagId: number) => {
  const reqData: aggr.TagQueryDetailRq = {
    mainTagId
  }
  const res = await handleApiStatus(() => tagApi.tagQuerydetail(reqData))
  return res
}

export const querySubtotal = async (term: string | null) => {
  const reqData: aggr.QuerySubtotalRq = {
    term
  }
  const res = await handleApiStatus(() => tagApi.tagQuerysubtotal(reqData))
  return res
}

export const queryTagInfo = async (mainTagId: number) => {
  const res = await handleApiStatus(() => tagApi.tagQuerytaginfo(mainTagId))
  return res
}

export const createTag = async (reqData: aggr.MainTagUpdateRq) => {
  const res = await handleApiStatus(() => tagApi.tagCreate(reqData))
  return res
}

export const updateTag = async (reqData: aggr.MainTagUpdateRq) => {
  const res = await handleApiStatus(() => tagApi.tagUpdate(reqData))
  return res
}

export const deleteTag = async (reqData: aggr.MainTagDeleteRq) => {
  const res = await handleApiStatus(() => tagApi.tagDelete(reqData))
  return res
}

export const exportAll = (reqData: aggr.TagExportAllRq) => {
  const res = handleApiStatus<any>(() => tagApi.tagExportall(reqData))
  return res
}

export const exportSelected = (reqData: aggr.TagExportSelectedRq) => {
  const res = handleApiStatus<any>(() => tagApi.tagExportselected(reqData))
  return res
}
